import { MatterStatus } from '~/gql/graphql';
import {
  matterStatusLabel,
  type MatterViewModel,
} from '~/modules/matters/matters.types';

export function getMatterStatusDisplayLabel(status: MatterStatus): string {
  return matterStatusLabel[status];
}

export interface GetMatterDisplayHeadingOptions {
  stripPotentialLabel?: boolean;
}

export function getMatterDisplayHeading(
  matter: Pick<MatterViewModel, 'title'>,
  options?: GetMatterDisplayHeadingOptions,
): string {
  let title = matter.title.trim() || 'Untitled Matter';
  if (options?.stripPotentialLabel) {
    title = title.replace(/\s*\(potential\)\s*$/i, '').trim();
    if (!title) {
      title = 'Untitled Matter';
    }
  }
  return title;
}
